export default __webpack_public_path__ + "static/media/companies.dcce1757.svg";